import Spinner from "./Spinner.jsx";

const Loader = ({ loading, title, message }) => {
  //const error = useSelector((state) => state.Reducer.error)
  return (
    //isEmpty(error) &&
    loading && (
      <div className="az-loading-container">
        <div className="text-center">
          <div className="d-flex justify-content-center mb-4">
            <Spinner size={40} />
          </div>

          <h1 className="az-pay-loading-message">{title || ""}</h1>

          <p className="az-pay-loading-desc">{message}</p>
        </div>
      </div>
    )
  );
};

export default Loader;
